@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

$var-image-size: 50px;
$var-signature-size: 72px;

.side-panel {
	display: flex;
	flex-direction: column;
	background-color: Colors.$col-greyBackground;
	height: 100%;

	&__block {
		border-bottom: 1px solid Colors.$col-greyConnection;

		&--primary {
			border-left: 4px solid Colors.$col-darkBlueBorder;
			background-color: Colors.$col-blueBackground;
		}

		&--secondary {
			background-color: Colors.$col-white;
		}

		&--secondary-main {
			background-color: Colors.$col-greyLight;
		}

		&__header {
			display: flex;
			padding: Constants.$val-spacing-m Constants.$val-spacing-l;
			text-transform: uppercase;
			font-weight: bold;
			cursor: pointer;

			& > [class^="icon-"] {
				margin-left: Constants.$val-spacing-m;
				font-size: Constants.$val-fontSizeXBig;
			}

			&--main {
				color: Colors.$col-design-blue500;
			}

			&--primary {
				background-color: Colors.$col-blueBackgroundDark;
			}

		}

		&__body {
			display: grid;
			grid-template-columns: 1fr 1fr;
		}

	}

	&__field {
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;

		&--span-one {
			grid-column: span 1;
		}

		&--span-two {
			grid-column: span 2;
		}

		& > img {
			height: $var-image-size;
			width: $var-image-size;
		}

		&--completed {
			display: flex;
			justify-content: flex-end;
			gap: Constants.$val-spacing-s;
			padding-right: Constants.$val-spacing-m;

		}

		&__name {
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-design-gray6;
			white-space: pre-wrap; // needed to keep the name in original format in order to be searchable in case of multiple consecutive white spaces

			&--repeated {
				margin-top: Constants.$val-spacing-s;
			}
		}

		&__value {
			font-weight: bold;
		}

		&__previewable-image {
			cursor: pointer;
		}

		&__immutable_link_field {
			cursor: pointer;
			color: Colors.$col-blue;
			word-break: break-word;
			
			&:hover {
				color: Colors.$col-blue !important;
			}
		}
	}

	&__signature-field {
		display: flex;
		flex-direction: column;
		grid-column: span 2;

		& > img {
			width: $var-signature-size;
			height: $var-signature-size;
		}
	}

	&__descriptive-text {
		color: Colors.$col-red;

		&--black-text {
			color: Colors.$col-black;
		}

		&--bold-text {
			font-weight: bold;
		}
	}

	&__loading {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}
